import { CorrectedRow, Leg } from "../models/couponshares";
import { Fixture } from "../models/fixture";
import { DetailedRound } from "../models/round";



const isFixtureAfterGameStart = (fixture: Fixture): boolean => {
        const startTime = new Date(fixture.startingAt).getTime();
        return startTime < Date.now() || ["PLAYING", "FINISHED"].includes(fixture.status ?? "");
    };


export function correctRows(rows: Leg[], round: DetailedRound, sortByFinished: boolean) {

    let correctedRows: CorrectedRow[] = []

    function getCorrectSign(index: number, round: DetailedRound) {
        if (!round.preliminaryCorrectRow) {
            return 'X';
        }
        return round.preliminaryCorrectRow[index];
    }

    rows.forEach(row => {

        let numCorrect = 0;
        let numCorrectCompleted = 0;
        let numCorrectStarted = 0;
        let numWrongCompleted = 0;

        for (let index = 0; index < row.signs.length; index++) {
            const sign = row.signs[index];
            const correctSign = getCorrectSign(index, round);
            const fixture = round.fixtures[index];
            const isAfterGameStart = isFixtureAfterGameStart(fixture);

            if (sign === correctSign) {
                numCorrect++;
                if (fixture.status === "FINISHED") {
                    numCorrectCompleted++;
                }
                if (isAfterGameStart) {
                    numCorrectStarted++;
                }
            }
            else {
                if (fixture.status === "FINISHED") {
                    numWrongCompleted++;
                }
            }

        }

        correctedRows.push({
            row: row, numCorrect: numCorrect, numCorrectCompleted: numCorrectCompleted,
            numCorrectStarted: numCorrectStarted, numPotential: round.fixtures.length - numWrongCompleted
        });
    });

    const sortFactor = sortByFinished ? 100000 : 0;

    correctedRows.sort((a, b) => {
        return sortFactor * (b.numCorrectCompleted - a.numCorrectCompleted) +
            (b.numCorrect - a.numCorrect);
    });

    return correctedRows;
}